import { render } from "./StartFreeTrialButton.vue?vue&type=template&id=ed87ab06&scoped=true"
const script = {}

import "./StartFreeTrialButton.vue?vue&type=style&index=0&id=ed87ab06&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed87ab06"]])

export default __exports__